import {register} from '@shopify/theme-sections'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
// import SearchPage from '../components/search-page';
import { getUrlParameterByName } from '../modules/utils'
// import SearchBar from '../components/search-bar'

// this should be imported globally via theme-header
import Sticky from '../modules/sticky'

import '../../styles/sections/collection-filters.scss'

export default register(`template-search`, {
  onLoad() {

    setTimeout(()=> {
      const stickyFilter = document.querySelector(`.filters-group`)
      if(stickyFilter) {
        this.sticky = new Sticky({
          target: `.filters-group`,
          fillHeight: false,
          heightElements: false,
          unstickElement: `#shopify-section-theme-footer`,
          bodyClass: `fixed-filter`
        })
      }
    },3000)
    const view = this.container.dataset.view || `product`
    const filterContainer = document.querySelector(`#filterContainer`)
    const collectionsContext = JSON.parse(this.container.querySelector(`[data-collections-json]`).innerHTML)
    const configAppCountry = this.container.dataset.shopCountry
    const shopifyAlgoliaIndicies = this.container.dataset.algoliaIndex
    const noResultContainer = this.container.querySelector(`[data-no-results]`)

  //   this.queue = new Q({
  //     url: '/apps/toolkit-b/client/filter-search/filters'
  //  });
  //   const request = {
  //     success: function success(response) {
  //       const filters = JSON.parse(response);
  //     }
  //   }
  //  this.queue.add(request)
    const $query = getUrlParameterByName(`Search`)

  if($query) {
    // ReactDOM.render(
    //   <SearchPage view={view} collections={collectionsContext} country={configAppCountry} ref={(query) => { window.searchQuery = query }}/>,
    //   this.container
    // );
  }
  else {
    // ReactDOM.render(<SearchBar country={configAppCountry}/>, this.container.querySelector('#filterSearchBar'));
    if(noResultContainer) {
      noResultContainer.classList.remove(`hide`)
    }
  }

  const backToTop = document.querySelector(`[data-back-top]`)
  const bodyWrapper = document.querySelector(`.body-wrapper`)
  const aboveTheFold = function(event) {
    const scroll = bodyWrapper.scrollTop
    if (scroll > 1000) {
      backToTop.classList.add(`active`)
    } else {
      backToTop.classList.remove(`active`)
    }
  }
  if (backToTop) {
    backToTop.addEventListener(`click`, (event) => {
      event.preventDefault()
      bodyWrapper.scrollTop = 0
    })

    bodyWrapper.addEventListener(`scroll`, aboveTheFold)
    bodyWrapper.addEventListener(`resize`, aboveTheFold)
    bodyWrapper.addEventListener(`orientationchange`, aboveTheFold)
  }

  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})
